import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { imageVariantLink } from '@/common/media';
import { Header } from '@/components/Header/Header';
import { LOGO_PICKER_HEIGHT, LOGO_PICKER_WIDTH, LogoPicker } from '@/components/Inputs';
import { Spacer } from '@/components/Spacer/Spacer';
import { useIsMobile } from '@/hooks/useIsMobile';
import { usePerson } from '@/store/persons/person.store';
import { toast } from '@/utils/toast';

export const EditPhotoPage = () => {
  const { me, currentUser, updateAvatar } = usePerson();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  useEffect(() => {
    void me();
  }, [me]);

  const handleSave = async (file: File) => {
    // Still loading: refuse rather than resolve, or the photo would look saved with nothing sent.
    if (!currentUser?.id) throw new Error('No current user yet');

    // A failure is LogoPicker's to report, with Retry.
    await updateAvatar(currentUser.id, file);
    toast.success('Avatar updated');
    navigate('/my-profile');
  };

  return (
    <>
      <Header title="Edit Photo" backButton />
      {isMobile && <Spacer height={30} />}
      <LogoPicker
        onChange={handleSave}
        initialLogo={imageVariantLink(currentUser?.avatar, LOGO_PICKER_WIDTH, LOGO_PICKER_HEIGHT)}
      />
    </>
  );
};
